import Vue from 'vue'
import VueRouter from 'vue-router'
import  routes  from './routers'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 全局前置路由守卫
router.beforeEach((to, from, next) => {

  if(to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  //  检查是否已登录（token 必须非空）
  const token = localStorage.getItem('X-Access-Token')
  const isLoggedIn = token != null && token !== ''
  if(to.name != 'login' && isLoggedIn) {
    next();   //继续
  } else if(to.name === 'login' && !isLoggedIn) {
    next();   //如果用户在访问登录页且未登录，也允许
  } else {
    // console.log(isLoggedIn,'全局路由守卫：', to, from, next)
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  }
})

export default router
